'use strict';

import _ from 'lodash';

function resizeObserve (element, callback, options = {}) {
  let isFirstTime = true;
  let prevWidth = 0;
  const observer = new ResizeObserver(_.debounce(entries => {
    const width = entries[0].contentRect.width;
    if (options.skipFirst === true && isFirstTime === true) {
      isFirstTime = false;
      prevWidth = width;
      return;
    }
    if (width <= 0) {
      prevWidth = width;
      return;
    }
    if (options.onlyWidth === true) {
      if (width !== prevWidth) {
        prevWidth = width;
        callback();
      }
      return;
    }
    prevWidth = width;
    callback();
  }, 250));
  observer.observe(element);
  return observer;
}

function resizeUnobserve (observer) {
  observer.disconnect();
}

export default {
  observe: resizeObserve,
  unobserve: resizeUnobserve
};
